export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkAbout: "nav-link-about",
  linkHowWeWork: "nav-link-how-we-work",
  linkClientStories: "nav-link-client-stories",
  linkResources: "nav-link-resources",
  linkContact: "nav-link-contact",
  ctaQuote: "nav-cta-quote",
  ctaContact: "nav-cta-contact",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const QUOTE = {
  root: "quote-page",
  name: "quote-name",
  business: "quote-business",
  email: "quote-email",
  phone: "quote-phone",
  pickup: "quote-pickup",
  dropoff: "quote-dropoff",
  packageType: "quote-package-type",
  weight: "quote-weight",
  date: "quote-date",
  timeWindow: "quote-time-window",
  frequency: "quote-frequency",
  notes: "quote-notes",
  submit: "quote-submit",
  success: "quote-success",
};

export const HERO = {
  root: "hero-root",
  headline: "hero-headline",
  ctaQuote: "hero-cta-quote",
  ctaWork: "hero-cta-work",
  image: "hero-image",
};

export const HOW = {
  root: "how-it-works",
  step: (n) => `how-step-${n}`,
};

export const SERVICES = {
  root: "services-section",
  zipInput: "zip-input",
  zipSubmit: "zip-submit",
  zipResult: "zip-result",
  card: (slug) => `service-card-${slug}`,
};

export const CONTACT = {
  root: "contact-section",
  formName: "contact-form-name",
  formBusiness: "contact-form-business",
  formEmail: "contact-form-email",
  formTopic: "contact-form-topic",
  formMessage: "contact-form-message",
  formSubmit: "contact-form-submit",
  success: "contact-success",
};

export const RESOURCES = {
  root: "resources-section",
  item: (slug) => `resources-item-${slug}`,
};

export const ANNOUNCE = {
  bar: "announcement-bar",
};

export const TRACK = {
  root: "tracking-bar",
  input: "tracking-input",
  submit: "tracking-submit",
};

export const PRIVACY = {
  root: "privacy-bar",
  accept: "privacy-accept-all",
  reject: "privacy-reject-all",
  manage: "privacy-manage",
  save: "privacy-save",
  toggleAnalytics: "privacy-toggle-analytics",
  toggleAds: "privacy-toggle-ads",
};

export const FOOTER = {
  root: "footer-root",
  linkResources: "footer-link-resources",
  linkContact: "footer-link-contact",
};
